import { render } from "./MainBtBanners.vue?vue&type=template&id=6fd5eb98&scoped=true"
import script from "./MainBtBanners.vue?vue&type=script&lang=js"
export * from "./MainBtBanners.vue?vue&type=script&lang=js"

import "./MainBtBanners.vue?vue&type=style&index=0&id=6fd5eb98&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6fd5eb98"]])

export default __exports__